import { FunctionComponent } from "react";
import { SignaturePicturePriorityEnum } from "@utils/enums/signature.picture.priority.enum";
import BasicButton from "@components/core/buttons/BasicButton";
import { useTranslation } from "react-i18next";
import CheckedLabel from "@components/core/labels/CheckedLabel";

interface SignatureNoPictureProps {
  isDefault: boolean;
  onSetDefaultPicture: (
    defaultSignature: SignaturePicturePriorityEnum,
    rank?: number,
    callback?: () => void,
  ) => void;
  row?: boolean;
}

const SignatureNoPicture: FunctionComponent<SignatureNoPictureProps> = ({
  isDefault,
  onSetDefaultPicture,
  row = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="position-relative d-flex align-items-center">
      <div
        className={`position-relative d-flex align-items-center gap-16 ${row ? "flex-row" : "flex-column"}`}
      >
        <CheckedLabel
          text={t(
            "account.mySignature.signaturePicture.noVisibleSignature.text",
          )}
          isChecked={isDefault}
        />
        <div>
          <div>
            {isDefault ? (
              <span>{t("account.mySignature.signaturePicture.selected")}</span>
            ) : (
              <BasicButton
                text={t("account.mySignature.signaturePicture.select")}
                onClick={() =>
                  onSetDefaultPicture(SignaturePicturePriorityEnum.NO_PICTURE)
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureNoPicture;
